import { ReactNode } from "react"

interface AuthLayoutProps {
  children: ReactNode
  applicationName?: string
}

export function AuthLayout({ children, applicationName }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800">
      <div className="flex min-h-screen flex-col items-center justify-center p-4">
        <div className="w-full max-w-md space-y-6">
          {/* Logo/Brand */}
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight text-slate-900 dark:text-slate-100">
              {applicationName || "Invisible Agentic Identity"}
            </h1>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">
              Secure authentication powered by passkeys
            </p>
          </div>
          
          {/* Main content */}
          {children}
        </div>
      </div>
    </div>
  )
}